import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

const ColorPickerStyled = styled.div`
  .containerColorPicker {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    gap: 10px !important;
    width: 100% !important;
    /* Como los inputs del tema: 40 px, borde de 1,5 px en gris, radio 8 */
    min-height: 40px;
    border: 1.5px solid ${color.border.default} !important;
    box-sizing: border-box !important;
    border-radius: 8px !important;
    background: ${color.background.default};
    padding: 4px 12px;
    position: relative;
  }

  .color-picker-container {
    position: relative !important;
  }

  .color-picker-button {
    cursor: pointer;
  }
  .color-picker-box {
    border: none;
    border-radius: 6px;
    width: 24px;
    height: 24px;
    padding: 0;
    transition: background-color 0.3s ease;
  }
  .swatches-picker {
    width: auto !important;
  }

  .swatches-picker-container {
    position: absolute !important;
    top: 40px !important;
    z-index: 1;
  }

  .color-code-text {
    font-size: 14px;
    font-weight: 400;
    color: ${color.text.primary};
  }
`

export default ColorPickerStyled
